export default import.meta.ROLLDOWN_FILE_URL_Ym8IzzZml2rKdD_0zc0hXg